import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { isEmpty } from "lodash";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
} from "reactstrap";
import {fetchDetails, insertDetails, updateDetails} from "helpers/backend_helper"
//redux
import { useSelector, useDispatch } from "react-redux";
import * as Yup from "yup";
import { useFormik } from "formik";
import CustomCreatableSelect from "components/Common/CustomCreatableSelect"
import { changePreloader } from "../../store/actions";
import { showSuccessAlert, showFailureAlert, findChangesV2 } from "helpers/function_helper"

const EventDetails = props => {
  const dispatch = useDispatch();
  const { match : { params } } = props

  const [inProgress, setInProgress] = useState(false);
  const [resetValue, setResetValue] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [currentEventDetails, setCurrentEventDetails] = useState();

  useEffect(()=>{
    if(params && params.id){
      setIsEdit(true)
      getCurrentEventDetails(params.id)
    }
  },[])

  const getCurrentEventDetails=async(id)=>{
    let inputToSend = {
      "data": {
        "type": 'EVENT_DETAILS',
        "user": {
          "id": id,
        }
      }
    }
    const resp = await fetchDetails(inputToSend)
    if(resp && resp.status=='success'){
      let tempTempResp = resp.data
      //
      validation.setValues(resp.data)
      
      setCurrentEventDetails(tempTempResp)
      validation.validateForm()
    }
  }

  const onSelect=(option)=>{
    //console.log('option:',option)
    validation.setFieldValue(option.objKey,option.selectedOption)
  }

  const validation = useFormik({
    enableReinitialize: false,
    initialValues: {
      eventName: '',
    },
    validationSchema: Yup.object({
      eventName: Yup.string().trim().required("Please enter a valid Event Name."),
    }),
    onSubmit: (values) => {
      saveDetails(values)
    }
  });

  const saveDetails = async(values)=>{
    setInProgress(true)
    dispatch(changePreloader(true))
    if(isEdit){
      const changes = findChangesV2({...currentEventDetails}, values ,[])
      if(changes.length == 0){
        showFailureAlert('Nothing to Update...')
        setInProgress(false)
        dispatch(changePreloader(false))
        return
      }
      let inputToSend = {
        "data": {
          "type": 'UPDATE_EVENT',
          "event":{
            ...values,
            log: changes,
          }
        }
      }
      const resp = await updateDetails(inputToSend)
      if(resp && resp.status == 'success'){
        showSuccessAlert('Updated Successfully!')
      }
      else{
        if(resp.error && resp.error.msg){
          showFailureAlert(resp.error.msg)
        }
        else{
          showFailureAlert('Unknown failure')
        }
      }
    }
    else{
      let inputToSend = {
        "data": {
          "type": 'NEW_EVENT',
          "event":{
            ...values
          }
        }
      }
      const resp = await insertDetails(inputToSend)
      //console.log('resp:',resp)
      if(resp && resp.status == 'success'){
        showSuccessAlert('Added Successfully!')
        validation.resetForm()
      }
    }

    setInProgress(false)
    dispatch(changePreloader(false))
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Row className="text-center mb-2">
                    <Col>
                      <span className="page-heading">{isEdit ? 'Edit ' : 'Create '} Event</span>
                    </Col>
                  </Row>
                  <Row className="mt-3 align-items-center">
                    <Col xs={12} md={12}>
                      <Row>
                        <Col xs={12} md={4} className="text-sm-start text-md-end">
                          <Label
                            htmlFor="name"
                            className="col-form-label"
                          >
                            Event Name :
                          </Label>
                        </Col>
                        <Col xs={12} md={4} className="">
                          <Input
                            maxLength={150}
                            type="text"
                            name="eventName"
                            className="form-control"
                            id="eventName"
                            placeholder="Event Name"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.eventName || ""}
                            invalid={
                              validation.touched.eventName && validation.errors.eventName ? true : false
                            }
                          />
                          {validation.touched.eventName && validation.errors.eventName ? (
                            <FormFeedback type="invalid">{validation.errors.eventName}</FormFeedback>
                          ) : null}
                        </Col>
                      </Row>
                    </Col>
                    
                  </Row>
                  
                  <Row className="mt-4 justify-content-center">
                    <Col className="text-center">
                      <Button
                        color="cust-1"
                        className="w-lg "
                        onClick={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                        disabled={inProgress}
                        >
                          Save
                          {inProgress && <i className="bx bx-loader bx-spin font-size-16 align-middle ms-2 me-2"></i>}
                      </Button>
                    </Col>
                  </Row>

                </CardBody>
              </Card>
            </Col>
          </Row>
          
        </Container>
      </div>
    </React.Fragment>
  );
};

EventDetails.propTypes = {
};

export default EventDetails;
